import api, { transformRequest, transformResponse } from "services/api";

export const accountsApi = api
  .enhanceEndpoints({ addTagTypes: ["Accounts", "DebtorProfiles"] })
  .injectEndpoints({
    endpoints: (build) => ({
      getDebtorCommunicationHistory: build.query({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/communications/`,
          method: "GET",
          params: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) =>
          results
            ? // successful query
              [
                ...results.map(({ id }) => ({ type: "Accounts", id })),
                { type: "Accounts", id: "LIST" },
              ]
            : // an error occurred, but we still want to refetch this query when `{ type: 'Accounts', id: 'LIST' }` is invalidated
              [{ type: "Accounts", id: "LIST" }],
      }),
      postDebtorCommunicationHistory: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/communications/create/`,
          method: "POST",
          body: transformRequest(payload.communication),
        }),
        transformResponse: (response) => transformResponse(response),
        // Invalidates all Account-type queries providing the `LIST` id - after all, depending of the sort order,
        // that newly created letter template could show up in any lists.
        invalidatesTags: (result, error, arg) => [
          { type: "Accounts", id: "LIST" },
          { type: "DebtorProfiles", id: "LIST" },
          { type: "DebtorProfiles", id: arg.debtorId },
        ],
      }),
    }),
    overrideExisting: false,
  });

export const { useGetDebtorCommunicationHistoryQuery, usePostDebtorCommunicationHistoryMutation } =
  accountsApi;
